import { render, staticRenderFns } from "./fdv.vue?vue&type=template&id=07f637d2"
import script from "./fdv.vue?vue&type=script&lang=js"
export * from "./fdv.vue?vue&type=script&lang=js"
import style0 from "./fdv.vue?vue&type=style&index=0&id=07f637d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports